{
  "expand": "Expand",
  "collapse": "Collapse"
}
